/* Load the existing Trustpilot integration only when the footer approaches the viewport. */
(() => {
  if (customElements.get('park-footer-trust')) return;
  let loading;
  const load = () => {
    if (window.Trustpilot) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      let script = document.querySelector('script[src*="widget.trustpilot.com/bootstrap/"]');
      const fresh = !script;
      if (fresh) {
        script = document.createElement('script');
        script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.async = true;
      }
      script.addEventListener('load', resolve, {once:true});
      script.addEventListener('error', reject, {once:true});
      if (fresh) document.head.appendChild(script);
    });
    return loading;
  };
  customElements.define('park-footer-trust', class extends HTMLElement {
    connectedCallback() {
      const footer = this.closest('footer');
      this.footerObserver = new IntersectionObserver(entries => {
        document.body.classList.toggle('cc-park-footer-visible', entries.some(entry => entry.isIntersecting));
      });
      if (footer) this.footerObserver.observe(footer);
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        load().then(() => {
          if (this.isConnected) window.Trustpilot?.loadFromElement(this.querySelector('.trustpilot-widget'), true);
        }).catch(() => { /* The accessible review link remains available. */ });
      }, {rootMargin:'200px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.footerObserver?.disconnect(); document.body.classList.remove('cc-park-footer-visible'); }
  });
})();
